// src/components/QuetionModal.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TreeSelect, Select, Button, Form, Modal, Input, Row, Col, Upload, AudioFilled, Radio, Textarea, InputNumber, UploadImg } from '../ui/ot';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';

const LanguageContext = createContext(null)

const ReplyCategoryModal = ({
    keyPrefix = "pmis.smartTaskSchedulingTaskReplyCategory",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {

    },
    onFinish = () => {

    },
    reloadTable = () => { },
    modalStyle = {},
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    openButtontext = "新增標籤分類",
    title = "新增標籤分類",
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const axiosModelanguage = {
        post: t('post'),
        patch: t('edit')
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])


    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                style={{ top: 10, }}
                contentStyle={{ padding: 16 }}
                // width={1000}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                okText={t('ok')}
                cancelText={t('cancel')}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                >
                    <Col span={24}>
                        <ReplyCategoryForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </LanguageContext.Provider>
    </>);
};
export default ReplyCategoryModal;



const ReplyCategoryForm = ({
    keyPrefix = "pmis.smartTaskSchedulingTaskReplyCategory",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    hasValue = false,
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setReplyCategoryId] = useState()
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        setReplyCategoryId(getAnyFormValue('reply_category_id'))
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };



    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        hidden={true}
                                        name={fieldName ? [fieldName, "reply_category_id"].join('.') : "reply_category_id"}

                                    >
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('reply_category_name')}
                                        name={fieldName ? [fieldName, "reply_category_name"].join('.') : "reply_category_name"}
                                        rules={!hasValue ? [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
export { ReplyCategoryForm }

